import React from "react";
// import ProjectEdit from "../views/pages/project/projectEdit.jsx";
// import Project from "../views/pages/project/project.jsx";

const Dashboard = React.lazy(() =>
  import("../../dashboard/views/dashboard/dashboard.jsx")
);
const User = React.lazy(() => import("../views/pages/user/user.jsx"));
const UserEdit = React.lazy(() => import("../views/pages/user/userEdit.jsx"));
const Group = React.lazy(() => import("../views/pages/group/group.jsx"));
const GroupEdit = React.lazy(() =>
  import("../views/pages/group/groupEdit.jsx")
);

// AMCATD
const Home = React.lazy(() =>
  import("../../dashboard/views/pages/home/home.jsx")
);
const HomeEdit = React.lazy(() =>
  import("../../dashboard/views/pages/home/homeEdit.jsx")
);
const MiniTitle = React.lazy(() =>
  import("../../dashboard/views/pages/miniTitle/miniTitle.jsx")
);
const MiniTitleEdit = React.lazy(() =>
  import("../../dashboard/views/pages/miniTitle/miniTitleEdit.jsx")
);
const AboutUs = React.lazy(() =>
  import("../../dashboard/views/pages/aboutUs/aboutUs.jsx")
);
const AboutUsEdit = React.lazy(() =>
  import("../../dashboard/views/pages/aboutUs/aboutUsEdit.jsx")
);
const Collaborator = React.lazy(() =>
  import("../../dashboard/views/pages/collaborator/collaborator.jsx")
);
const CollaboratorEdit = React.lazy(() =>
  import("../../dashboard/views/pages/collaborator/collaboratorEdit.jsx")
);
const Project = React.lazy(() =>
  import("../../dashboard/views/pages/project/project.jsx")
);
const ProjectEdit = React.lazy(() =>
  import("../../dashboard/views/pages/project/projectEdit.jsx")
);
const Property = React.lazy(() =>
  import("../../dashboard/views/pages/property/property.jsx")
);
const PropertyEdit = React.lazy(() =>
  import("../../dashboard/views/pages/property/propertyEdit.jsx")
);
const AccountabilityEdit = React.lazy(() =>
  import("../../dashboard/views/pages/accountability/accountabilityEdit.jsx")
);
const Accountability = React.lazy(() =>
  import("../../dashboard/views/pages/accountability/accountability.jsx")
);
const NewsEdit = React.lazy(() =>
  import("../../dashboard/views/pages/news/newsEdit.jsx")
);
const News = React.lazy(() =>
  import("../../dashboard/views/pages/news/news.jsx")
);
const JournalEdit = React.lazy(() =>
  import("../../dashboard/views/pages/journal/journalEdit.jsx")
);
const Journal = React.lazy(() =>
  import("../../dashboard/views/pages/journal/journal.jsx")
);
const EventEdit = React.lazy(() =>
  import("../../dashboard/views/pages/event/eventEdit.jsx")
);
const Event = React.lazy(() =>
  import("../../dashboard/views/pages/event/event.jsx")
);
const SpaceEdit = React.lazy(() =>
  import("../../dashboard/views/pages/space/spaceEdit.jsx")
);
const Space = React.lazy(() =>
  import("../../dashboard/views/pages/space/space.jsx")
);

const routes = [
  { path: "/", name: "dashboard", element: Dashboard },
  { path: "/access/user", name: "user", element: User },
  {
    path: "/access/user/:id",
    name: "user",
    element: UserEdit,
    exact: true,
  },
  {
    path: "/access/group",
    name: "group",
    element: Group,
  },
  {
    path: "/access/group/:id",
    name: "group",
    element: GroupEdit,
    exact: true,
  },
  {
    path: "/home/associados",
    name: "associates",
    element: User,
    exact: true,
  },
  { path: "/home", name: "home", element: Home },
  { path: "/home/home", name: "home", element: Home },
  {
    path: "/home/home/:id",
    name: "home",
    element: HomeEdit,
    exact: true,
  },
  {
    path: "/home/mini_title",
    name: "mini_title",
    element: MiniTitle,
    exact: true,
  },
  {
    path: "/home/mini_title/:id",
    name: "mini_title",
    element: MiniTitleEdit,
    exact: true,
  },
  {
    path: "/about_us",
    name: "about_us",
    element: AboutUs,
  },
  {
    path: "/about_us/about_us",
    name: "about_us",
    element: AboutUs,
  },
  {
    path: "/about_us/about_us/:id",
    name: "about_us",
    element: AboutUsEdit,
    exact: true,
  },
  {
    path: "/about_us/accountability",
    name: "accountability",
    element: Accountability,
  },
  {
    path: "/about_us/accountability/:id",
    name: "accountability",
    element: AccountabilityEdit,
    exact: true,
  },
  {
    path: "/about_us/property",
    name: "property",
    element: Property,
    exact: true,
  },
  {
    path: "/about_us/property/:id",
    name: "property",
    element: PropertyEdit,
    exact: true,
  },
  {
    path: "/about_us/project",
    name: "projects_and_partners",
    element: Project,
    exact: true,
  },
  {
    path: "/about_us/project/:id",
    name: "projects_and_partners",
    element: ProjectEdit,
    exact: true,
  },
  {
    path: "/about_us/collaborator",
    name: "collaborator",
    element: Collaborator,
  },
  {
    path: "/about_us/collaborator/:id",
    name: "collaborator",
    element: CollaboratorEdit,
    exact: true,
  },
  {
    path: "/about_us/accountability",
    name: "accountability",
    element: Accountability,
    exact: true,
  },
  {
    path: "/about_us/accoutability/:id",
    name: "accountability",
    element: AccountabilityEdit,
    exact: true,
  },
  {
    path: "/informative/news",
    name: "news",
    element: News,
    exact: true,
  },
  {
    path: "/informative/news/:id",
    name: "news",
    element: NewsEdit,
    exact: true,
  },
  {
    path: "/informative/journal",
    name: "journal",
    element: Journal,
    exact: true,
  },
  {
    path: "/informative/journal/:id",
    name: "journal",
    element: JournalEdit,
    exact: true,
  },
  {
    path: "/event/photos_events",
    name: "photos_events",
    element: Event,
    exact: true,
  },
  {
    path: "/event/photos_events/:id",
    name: "photos_events",
    element: EventEdit,
    exact: true,
  },
  {
    path: "/event/space_reservations",
    name: "space_reservations",
    element: Space,
    exact: true,
  },
  {
    path: "/event/space_reservations/:id",
    name: "space_reservations",
    element: SpaceEdit,
    exact: true,
  },
];

export default routes;
